import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import api from "../api";
import { Button } from "./ui/button";

/**
 * Iter37 sexies — Compact banner shown on MnsDashboard when the MNS profile
 * is hard-blocked (>30j expired docs). Links directly to /profile?tab=diplomas.
 */
export default function MnsHardBlockBanner() {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get("/profile/mns")
      .then((r) => {
        if (cancelled) return;
        const p = r.data || {};
        const c = p.completeness || {};
        // hard_block flag from completeness OR persisted flag on user doc
        setBlocked(!!c.hard_block || !!p.mns_hard_blocked);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!blocked) return null;
  return (
    <div className="mb-5 rounded-2xl p-4 border-2 border-red-400 bg-red-50 flex items-center justify-between gap-3 flex-wrap"
         data-testid="mns-hard-block-banner">
      <div className="flex items-start gap-3">
        <Lock className="w-5 h-5 text-red-700 shrink-0 mt-0.5" />
        <div>
          <div className="font-bold text-red-900" style={{ fontFamily: "Outfit" }}>
            Publication de créneaux suspendue
          </div>
          <div className="text-sm text-red-800">
            Un ou plusieurs documents obligatoires sont expirés depuis plus de 30 jours.
            Renouvelez-les depuis votre profil pour rétablir la publication.
          </div>
        </div>
      </div>
      <Link to="/profile?tab=diplomas">
        <Button className="rounded-full bg-red-700 hover:bg-red-600 text-white" data-testid="mns-hard-block-cta">
          Voir mes documents →
        </Button>
      </Link>
    </div>
  );
}
